import { create } from 'zustand'
import { drugApi } from '@/api/drugApi'

const PAGE = 100

export const useDrugStore = create((set, get) => ({
  list: [],
  total: 0,
  loading: false,
  loadingMore: false,
  hasMore: false,
  query: { search: '', category: '', filter: '' },

  /* Reset and reload from offset 0 */
  fetchList: async (queryPatch = {}) => {
    const query = { ...get().query, ...queryPatch }
    set({ loading: true, query })
    try {
      const params = { limit: PAGE, offset: 0 }
      if (query.search) params.search = query.search
      if (query.category) params.category = query.category
      if (query.filter && query.filter !== 'all') params.filter = query.filter
      const rows = await drugApi.list(params)
      set({
        list: rows,
        hasMore: rows.length === PAGE,
        loading: false,
      })
    } catch (e) {
      set({ loading: false })
      throw e
    }
  },

  nextPage: async () => {
    const { list, query, hasMore, loadingMore } = get()
    if (!hasMore || loadingMore) return
    set({ loadingMore: true })
    try {
      const params = { limit: PAGE, offset: list.length }
      if (query.search) params.search = query.search
      if (query.category) params.category = query.category
      if (query.filter && query.filter !== 'all') params.filter = query.filter
      const rows = await drugApi.list(params)
      set({
        list: [...list, ...rows],
        hasMore: rows.length === PAGE,
        loadingMore: false,
      })
    } catch (e) {
      set({ loadingMore: false })
      throw e
    }
  },

  upsert: (drug) => {
    if (!drug?.drug_id) return
    const list = get().list
    const idx = list.findIndex((d) => d.drug_id === drug.drug_id)
    if (idx >= 0) {
      const next = [...list]
      next[idx] = { ...next[idx], ...drug }
      set({ list: next })
    } else {
      set({ list: [drug, ...list] })
    }
  },

  remove: (drug_id) =>
    set((state) => ({ list: state.list.filter((d) => d.drug_id !== drug_id) })),
}))
